/* @flow */
import React from 'react';

type Props = {
  value: string,
  text?: string,
};

const MailTo = ({ value, text = value }: Props) => (
  <a href={`mailto:${String(value)}`}>{text}</a>
);

export default MailTo;



// WEBPACK FOOTER //
// ./src/modules/components/MailTo.js